module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("\n\t\t\t控制台\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "control-user-info"
  }, [_c('div', {
    staticClass: "befDiv"
  }, [_c('router-link', {
    staticClass: "icons xf_icon",
    attrs: {
      "to": "/user/message"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "midP"
  }, [_vm._v("-")]), _vm._v(" "), _c('router-link', {
    staticClass: "butP",
    attrs: {
      "to": "/user/message"
    }
  }, [_vm._v("站内信")])], 1), _vm._v(" "), _c('div', {
    staticClass: "befDiv"
  }, [_c('router-link', {
    staticClass: "gd_icon icons",
    attrs: {
      "to": "/user/gongdan"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "midP"
  }, [_vm._v("-")]), _vm._v(" "), _c('router-link', {
    staticClass: "butP",
    attrs: {
      "to": "/user/gongdan"
    }
  }, [_vm._v("工单")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "project-grid"
  }, [_c('h4', [_vm._v("我的云产品")]), _vm._v(" "), _c('grid', {
    attrs: {
      "show-lr-borders": true,
      "show-vertical-dividers": true
    }
  }, [_c('grid-item', {
    attrs: {
      "link": "/user/serverManage",
      "label": "云服务器"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/img/ctrl_vps.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "link": "/user/host",
      "label": "虚拟主机"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/img/ctrl_host.png")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('grid-item', {
    attrs: {
      "link": "/user/domain",
      "label": "域名"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/img/ctrl_domain.png")
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "console"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54525e94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/index.vue
// module id = h258
// module chunks = 1